/* eslint-disable no-nested-ternary */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import { metricDescriptions } from '../../metricConstants';
import Button from '../../../../shared/components/Button/Button';
import { BoxShadow } from '../../../../shared/GlobalStyles';
import { setIsMetricInfoModalShowing } from '../../ducks/forcePlateDashboardActions';
import SharedTemplateModalContainer from '../../../sports-science/components/presentational/sharedTemplateComponents/SharedTemplateModalContainer';

const ModalContainer = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  top: 50%;
  left: 50%;
  transform: ${({ isSideBarExpanded, isReadOnlyView }) => (isReadOnlyView
    ? 'translate(-50%, -50%)'
    : isSideBarExpanded
      ? 'translate(calc(-50% + 150px), -50%)'
      : 'translate(calc(-50% + 48px), -50%)')};
  background-color: #ffffff;
  width: 500px;
  padding: 24px;
  border-radius: 8px;
  font-family: 'Nunito Sans';
  box-shadow: ${BoxShadow};
  z-index: 1003;

  @media screen and (min-width: 714px) and (max-width: 800px) {
    transform: ${({ isSideBarExpanded, isReadOnlyView }) => (isReadOnlyView
    ? 'translate(-50%, -50%)'
    : isSideBarExpanded
      ? 'translate(-30%, -50%)'
      : 'translate(calc(-50% + 48px), -50%)')};
  }

  @media screen and (max-width: 714px) {
    transform: translate(-50%, -50%);
  }

  @media screen and (max-width: 500px) {
    left: 0;
    width: 100%;
    margin-left: 0;
    transform: translate(0, -50%);
  }
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Header = styled('div')`
  font-size: 16px;
  color: #9e9e9e;
`;

const Title = styled('div')`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const Description = styled('div')`
  font-size: 16px;
  white-space: pre-line;
`;

const MetricInfoModal = () => {
  const dispatch = useDispatch();
  const isSideBarExpanded = useSelector(
    (state) => state.sportsScience.data.isSideBarExpanded,
  );
  const infoModalMetric = useSelector(
    (state) => state.forcePlateDashboard.ui.infoModalMetric,
  );
  const isModalShowing = useSelector(
    (state) => state.forcePlateDashboard.ui.isMetricInfoModalShowing,
  );
  const isReadOnlyView = useSelector(
    (state) => state.forcePlateDashboard.ui.isReadOnlyView,
  );

  const handleClose = () => {
    dispatch(setIsMetricInfoModalShowing(false, ''));
  };

  return (
    <>
      <ModalContainer
        isSideBarExpanded={isSideBarExpanded}
        isReadOnlyView={isReadOnlyView}
      >
        <HeaderContainer>
          <Header>Standardized Name</Header>
          <Button icon='remove' iconOnly onClick={handleClose} />
        </HeaderContainer>
        <Title>{infoModalMetric}</Title>
        <Description>{metricDescriptions[infoModalMetric] || null}</Description>
      </ModalContainer>
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
      />
    </>
  );
};

export default MetricInfoModal;
